import React from 'react'
import Link from 'gatsby-link'
import cc from 'classcat'
import LanguageDropdown from '../LanguageDropdown'
import MapIcon from '../Icons/Map'
import PhoneIcon from '../Icons/Phone'
import DropdownIcon from '../Icons/Dropdown'

import s from './styles.module.css'

const Header = ({
  className,
  locale,
  languageDropdownClassName,
  onLocaleChange
}) => (
  <header className={cc([s.header, className])}>
    <div className={s.link}>
      <Link className={s.howToFindUs} to={`/${locale}/contact`}>
        <MapIcon className={s.mapIcon} width={10} height={15} />How to Find Us
      </Link>
      <a className={s.call} href="tel:+38598571884">
        <PhoneIcon className={s.mapIcon} width={10} height={15} />+385 985 718 84
      </a>
    </div>
    {/* <LanguageDropdown
      locale={locale}
      dropdownClassName={languageDropdownClassName}
      onLocaleChange={onLocaleChange}
      className={s.languageDropdown}
    /> */}
  </header>
)

export default Header



// WEBPACK FOOTER //
// ./src/components/Header/index.js